import { localManufacturerImage } from './localManufacturerImages.js';
export const MANUFACTURER_HERO_IMAGES = {
  "/brands/alterna": {
    "baseName": "brand-armstrong-alterna",
    "alt": "Armstrong Alterna groutable engineered tile in a kitchen",
    "width": 769,
    "height": 768
  },
  "/brands/bella-cera": {
    "baseName": "bella-cera-aged-french-oak-michigan",
    "alt": "Bella Cera Villa Borghese II wide plank French oak floor in Gallipoli",
    "width": 1920,
    "height": 1080
  },
  "/brands/bella-cera/villa-borghese-ii": {
    "baseName": "bella-cera-aged-french-oak-michigan",
    "alt": "Bella Cera Villa Borghese II wide plank French oak floor in Gallipoli",
    "width": 1920,
    "height": 1080
  },
  "/brands/ironwood": {
    "baseName": "bamboo-eucalyptus-kitchen-hero",
    "alt": "Milano Toasted eucalyptus bamboo floor in a kitchen",
    "width": 815,
    "height": 561
  },
  "/brands/lauzon": {
    "baseName": "lauzon-expert-hardwood-michigan",
    "alt": "Expert by Lauzon solid and engineered hardwood floor",
    "width": 1024,
    "height": 510
  },
  "/brands/mercier": {
    "baseName": "mercier-stellar-white-oak-michigan",
    "alt": "Mercier Stellar white oak hardwood floor",
    "width": 1600,
    "height": 1600
  },
  "/brands/mercier/atmosphere": {
    "baseName": "mercier-atm-whisper",
    "alt": "Mercier Atmosphere Collection hardwood floor in Whisper",
    "width": 480,
    "height": 650
  },
  "/brands/mercier/design-plus": {
    "baseName": "mercier-dp-ivoor-maple",
    "alt": "Mercier Design+ Collection maple floor in Ivoor",
    "width": 1600,
    "height": 973
  },
  "/brands/mercier/elegancia": {
    "baseName": "mercier-elegancia-hardwood",
    "alt": "Mercier Elegancia Collection European inspired hardwood floor",
    "width": 1600,
    "height": 973
  },
  "/brands/mercier/element": {
    "baseName": "mercier-collection-element",
    "alt": "Mercier Element Collection contemporary hardwood floor",
    "width": 1600,
    "height": 973
  },
  "/brands/mercier/emblem": {
    "baseName": "mercier-emblem-noble",
    "alt": "Mercier Emblem wide plank hardwood floor in Noble",
    "width": 1600,
    "height": 973
  },
  "/brands/mercier/herringbone": {
    "baseName": "mercier-herringbone-natural-whiteoak",
    "alt": "Mercier Herringbone Collection white oak floor in Natural",
    "width": 1600,
    "height": 973
  },
  "/brands/mercier/naked": {
    "baseName": "mercier-naked-whiteoak",
    "alt": "Mercier Naked Collection raw look white oak floor",
    "width": 1600,
    "height": 973
  },
  "/brands/mercier/origins": {
    "baseName": "mercier-origins-whiteoak-natural",
    "alt": "Mercier Origins Collection white oak floor in Natural",
    "width": 480,
    "height": 650
  },
  "/brands/mercier/pro": {
    "baseName": "mercier-pro-natural-redoak",
    "alt": "Mercier PRO Collection red oak floor in Natural for commercial spaces",
    "width": 1600,
    "height": 973
  },
  "/brands/mercier/source": {
    "baseName": "mercier-source-collection-hero",
    "alt": "Mercier Source Collection warm stained hardwood floor",
    "width": 682,
    "height": 450
  },
  "/brands/mercier/stellar": {
    "baseName": "mercier-stellar-white-oak-michigan",
    "alt": "Mercier Stellar Collection wide plank white oak floor",
    "width": 1600,
    "height": 1600
  },
  "/brands/viking/big-sky": {
    "baseName": "viking-big-sky-mazama",
    "alt": "Viking Big Sky Mazama 9\u00bd inch engineered solid European white oak floor",
    "width": 1600,
    "height": 1000
  },
  "/brands/viking/modern-loft": {
    "baseName": "viking-ml-heath",
    "alt": "Viking Modern Loft brushed European white oak engineered floor in Heath",
    "width": 1200,
    "height": 750
  },
  "/brands/viking/urban-rustic": {
    "baseName": "viking-ur-tidal",
    "alt": "Viking Urban Rustic wire brushed European white oak engineered floor in Tidal",
    "width": 1600,
    "height": 1000
  },
  "/brands/indusparquet": {
    "baseName": "https://www.indusparquet-usa.com/cdn/shop/files/hdr_collections_ip.jpg?v=1738174604&width=1741",
    "alt": "Indusparquet Brazilian hardwood flooring collections",
    "width": 1741,
    "height": 920
  }
};

export function normalizeLauzonAlt(alt) {
  return alt.replace(/hardwood flooring Michigan$/, "hardwood floor").replace(/Vendôme/g, "Vendome").replace(/ {2,}/g, ", ");
}

export function makeManufacturerShareImage(path, resolveImage) {
  const photo = MANUFACTURER_HERO_IMAGES[path];
  if (!photo) return undefined;
  const local = localManufacturerImage(photo.baseName);
  const url = local.startsWith('/images/') ? `https://1woodfloors.com${local}` : photo.baseName.startsWith("https://") ? photo.baseName : resolveImage(photo.baseName);
  return url ? { url, width: photo.width, height: photo.height, alt: photo.alt } : undefined;
}
